"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var getAddressString = function getAddressString(address) {
  if ((0, _lodash.isEmpty)(address)) {
    return '';
  }
  var street = (0, _lodash.trim)("".concat((0, _lodash.get)(address, 'line_1') || '', " ").concat((0, _lodash.get)(address, 'line_2') || ''));
  var city = (0, _lodash.trim)((0, _lodash.get)(address, 'city') || '');
  var stateAndZip = (0, _lodash.trim)("".concat((0, _lodash.get)(address, 'state') || '', " ").concat((0, _lodash.get)(address, 'postal_code') || ''));
  var addressParts = (0, _lodash.compact)([street, city, stateAndZip]);
  return (0, _lodash.isEmpty)(addressParts) ? '' : (0, _lodash.join)(addressParts, ', ');
};
var _default = exports["default"] = getAddressString;